require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-chief-strategy-officer.json") })
        }
      }, "path---articles-tags-chief-strategy-officer");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-chief-strategy-officer!./.cache/json/articles-tags-chief-strategy-officer.json
// module id = 1784
// module chunks = 231608221292675